var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"micro-sidebar"},[_c('el-menu',{staticClass:"sidebar-el-menu",attrs:{"default-active":_vm.currentRoute}},_vm._l((_vm.menuList),function(item,i){return _c('div',{key:i},[_c('SideBarItem',{attrs:{"item":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }